import { Element } from '@thive/canvas';
import { Group } from '@thive/fddm-types';

import { elementFactory } from '@/modules/canvas/factories';
import { FDDM_TAG } from '@/modules/floorplanDesign/constants';

export const templateMapper = (groups: Group[]): Element[] => {
  const elements: Element[] = [];

  groups.forEach((group) => {
    elements.push(
      elementFactory.buildGroupLogicalElement({
        id: group.id,
        name: group.name,
        interactivity: {
          selectable: true,
          draggable: true,
          rotatable: true,
          clickable: false,
          snappable: false,
          editable: false,
        },
        tags: [FDDM_TAG.TEMPLATE],
      }),
    );
  });

  return elements;
};
